function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (app, mod, invite) {
  var _invite$game_mod$resp, _invite$options;
  var image = ((_invite$game_mod$resp = invite.game_mod.respondTo('arcade-games')) === null || _invite$game_mod$resp === void 0 ? void 0 : _invite$game_mod$resp.image) || '';
  var tentative = invite.tentative || {
    join: [],
    leave: []
  };
  var leaving = new Set(tentative.leave || []);
  var isInPlay = !invite.time_finished && invite.players.length >= invite.players_needed;
  var stateLabel = 'Open Invite';
  if (isInPlay) {
    stateLabel = 'In Play';
  }
  if (invite.time_finished) {
    stateLabel = 'Finished Game';
  }
  var playersHtml = '';
  var playerCount = 0;

  // Render players who have joined (marking any about to leave).
  var _iterator = _createForOfIteratorHelper(invite.players),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _invite$winner;
      var _pkey = _step.value;
      var isLeaving = leaving.has(_pkey);
      playersHtml += playerBox(app, _pkey, isLeaving ? 'leaving' : '', isLeaving ? 'leaving next hand' : '', (_invite$winner = invite.winner) === null || _invite$winner === void 0 ? void 0 : _invite$winner.includes(_pkey));
      playerCount++;
    }

    // Render tentative joiners (pending seat requests not yet seated).
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(tentative.join || []),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _pkey2 = _step2.value;
      if (!invite.players.includes(_pkey2)) {
        playersHtml += playerBox(app, _pkey2, 'pending', 'joining next hand');
        playerCount++;
      }
    }

    // Render players who were specifically requested to join.
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var _iterator3 = _createForOfIteratorHelper(invite.desired_opponent_publickeys),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _pkey3 = _step3.value;
      playersHtml += playerBox(app, _pkey3, 'arcade-lounge-playerbox--requested');
      playerCount++;
    }

    // Empty seats are status indicators, not interactive checkboxes.
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  for (var i = 0; i < invite.empty_slots; i++) {
    playersHtml += "\n      <div class=\"arcade-lounge-playerbox arcade-lounge-playerbox--open saito-table-row\">\n        <div class=\"saito-identicon-box empty-slot\" aria-hidden=\"true\"></div>\n        <div class=\"arcade-lounge-player-identity\">\n          <div class=\"saito-address\">Open</div>\n        </div>\n      </div>";
    playerCount++;
  }
  var eliminated = ((_invite$options = invite.options) === null || _invite$options === void 0 ? void 0 : _invite$options.eliminated) || {};
  var eliminatedHtml = '';
  for (var pkey in eliminated) {
    if (!invite.players.includes(pkey)) {
      var amt = typeof eliminated[pkey] === 'string' ? eliminated[pkey] : '';
      eliminatedHtml += playerBox(app, pkey, 'eliminated', amt ? "cashed out ".concat(amt) : 'left the table');
    }
  }
  var detailsHtml = formatOptions(invite.game_mod.returnShortGameOptionsArray(invite.options));
  if (invite.time_finished) {
    detailsHtml += addTimeStamp('finished at', app.browser.formatDate(invite.time_finished));
  } else if (invite.time_created) {
    detailsHtml += addTimeStamp('created at', app.browser.formatDate(invite.time_created));
  }
  if ((invite === null || invite === void 0 ? void 0 : invite.step) >= 0) {
    detailsHtml += detailRow('game moves', invite.step);
    if (invite !== null && invite !== void 0 && invite.game_status) {
      detailsHtml += detailRow('status', invite.game_status);
    }
  }
  if (invite !== null && invite !== void 0 && invite.method) {
    detailsHtml += detailRow('game ending', invite.method);
  }
  var controls = renderControls(mod, invite);
  var playerRows = Math.min(3, Math.max(1, Math.ceil(playerCount / 2)));
  var controlsState = isInPlay ? 'arcade-lounge-controls--in-play' : 'arcade-lounge-controls--standard';
  var gameStatus = app.browser.escapeHTML(String(invite.game_status || ''));
  var cryptoStake = invite.economic_line ? "<div class=\"arcade-lounge-current-stake\"><span class=\"arcade-lounge-current-stake-label\">Stake</span>".concat(app.browser.escapeHTML(String(invite.economic_line)), "</div>") : '';
  var headingStatus = isInPlay ? "".concat(gameStatus ? "<div class=\"arcade-lounge-current-status\">".concat(gameStatus, "</div>") : '').concat(cryptoStake) : "<h3 class=\"arcade-lounge-header-desc\">".concat(stateLabel, "</h3>");
  var detailsId = 'arcade-lounge-game-details';
  var detailsToggle = isInPlay ? "<button type=\"button\" id=\"arcade-lounge-details-toggle\" class=\"arcade-lounge-details-toggle\" aria-expanded=\"false\" aria-controls=\"".concat(detailsId, "\">details</button>") : '';
  var eliminatedSection = eliminatedHtml ? "<div class=\"arcade-lounge-eliminated-label\">Cashed out</div>\n       <div class=\"arcade-lounge-players arcade-lounge-eliminated\">".concat(eliminatedHtml, "</div>") : '';
  return "\n    <div class=\"arcade-lounge arcade-lounge--invite arcade-lounge--four-sector saito-overlay-panel\">\n      <div class=\"arcade-lounge-art\">\n        <img class=\"arcade-lounge-hero\" src=\"".concat(image, "\" alt=\"\">\n      </div>\n\n      <section class=\"arcade-lounge-info\" aria-labelledby=\"arcade-lounge-title\">\n        <h1 id=\"arcade-lounge-title\" class=\"arcade-lounge-header-title\">").concat(invite.game_name, "</h1>\n        ").concat(headingStatus, "\n        <div id=\"").concat(detailsId, "\" class=\"arcade-lounge-details saito-table\"").concat(isInPlay ? ' hidden' : '', ">\n          <div class=\"saito-table-body\">").concat(detailsHtml, "</div>\n        </div>\n        ").concat(detailsToggle, "\n      </section>\n\n      <section class=\"arcade-lounge-section hide-scrollbar\" aria-label=\"Players\">\n        <div class=\"arcade-lounge-players\">").concat(playersHtml, "</div>\n        ").concat(eliminatedSection, "\n      </section>\n\n      <div class=\"arcade-lounge-chat\"></div>\n      <div class=\"arcade-lounge-controls ").concat(controlsState, " arcade-lounge-controls--").concat(playerRows, "-rows arcade-lounge-controls--").concat(controls.length, "-actions\">").concat(controls.join(''), "</div>\n    </div>");
};
var playerBox = function playerBox(app, pkey) {
  var extraClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var note = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var winner = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return "\n  <div class=\"arcade-lounge-playerbox saito-table-row ".concat(extraClass, "\" id=\"invite-user-").concat(pkey, "\">\n    <div class=\"saito-identicon-box").concat(winner ? ' winner' : '', "\">\n      <img class=\"saito-identicon\" src=\"").concat(app.keychain.returnIdenticon(pkey), "\">\n      ").concat(note ? '' : '<div class="online-status-indicator"></div>', "\n    </div>\n    <div class=\"arcade-lounge-player-identity\">\n      ").concat(app.browser.returnAddressHTML(pkey), "\n      <div class=\"arcade-lounge-player-key\" title=\"").concat(app.browser.escapeHTML(pkey), "\">").concat(app.browser.escapeHTML(pkey), "</div>\n      ").concat(note ? "<div class=\"arcade-lounge-player-note\">".concat(note, "</div>") : '', "\n    </div>\n  </div>");
};
var renderControls = function renderControls(mod, invite) {
  var controls = [];
  if (!invite.time_finished) {
    if (invite.players.length >= invite.players_needed) {
      var _invite$tentative;
      if (invite.players.includes(mod.publicKey)) {
        controls.push("<div id=\"arcade-game-controls-continue-game\" class=\"saito-button-primary\">continue</div>");
        if (invite.players.length > 1) {
          controls.push("<div id=\"arcade-game-controls-forfeit-game\" class=\"saito-button-secondary\">forfeit</div>");
        }
        controls.push("<div id=\"arcade-game-controls-close-game\" class=\"saito-button-secondary\">cancel</div>");
      } else if ((_invite$tentative = invite.tentative) !== null && _invite$tentative !== void 0 && (_invite$tentative = _invite$tentative.join) !== null && _invite$tentative !== void 0 && _invite$tentative.includes(mod.publicKey)) {
        controls.push("<div id=\"arcade-game-controls-continue-join\" class=\"saito-button-primary\">continue</div>", "<div id=\"arcade-game-controls-cancel-tentative\" class=\"saito-button-secondary\">cancel</div>");
      } else if (invite.empty_slots) {
        controls.push("<div id=\"arcade-game-controls-join-table\" class=\"saito-button-primary\">join table</div>");
      } else if (invite.game_mod.enable_observer) {
        controls.push("<div id=\"arcade-game-controls-watch-game\" class=\"saito-button-primary\">watch game</div>");
        if (invite.game_mod.doesGameExistLocally(invite.game_id)) {
          controls.push("<div id=\"arcade-game-controls-clear-game\" class=\"saito-button-secondary\">clear</div>");
        }
      }
    } else if (invite.players.includes(mod.publicKey)) {
      if (mod.publicKey === invite.originator) {
        controls.push("<div id=\"arcade-game-controls-invite-join\" class=\"saito-button-primary\"><i class=\"fa-solid fa-link\"></i>share</div>", "<div id=\"arcade-game-controls-cancel-join\" class=\"saito-button-secondary\">cancel</div>");
      } else {
        controls.push("<div id=\"arcade-game-controls-cancel-join\" class=\"saito-button-secondary\">leave invite</div>");
      }
    } else if (invite.empty_slots > 0) {
      controls.push("<div id=\"arcade-game-controls-join-game\" class=\"saito-button-primary\">join game</div>");
    } else if (invite.desired_opponent_publickeys.includes(mod.publicKey)) {
      controls.push("<div id=\"arcade-game-controls-join-game\" class=\"saito-button-primary\">join game</div>", "<div id=\"arcade-game-controls-cancel-join\" class=\"saito-button-secondary\">decline invite</div>");
    }
  } else if (invite.game_mod.doesGameExistLocally(invite.game_id)) {
    controls.push("<div id=\"arcade-game-controls-continue-game\" class=\"saito-button-primary\">view game</div>");
  } else if (invite.game_mod.enable_observer && (invite === null || invite === void 0 ? void 0 : invite.step) > 0) {
    controls.push("<div id=\"arcade-game-controls-review-game\" class=\"saito-button-primary\">review game</div>");
  }
  return controls;
};
var detailRow = function detailRow(label, value) {
  return "<div class=\"saito-table-row\">\n  <div class=\"arcade-lounge-key\">".concat(label, "</div>\n  <div class=\"arcade-lounge-value\">").concat(value, "</div>\n</div>");
};
var formatOptions = function formatOptions(sgoa) {
  var html = '';
  for (var key in sgoa) {
    if (sgoa[key] !== null) {
      html += detailRow(key.replace(/_/g, ' '), sgoa[key]);
    } else {
      html += "<div class=\"saito-table-row\"><div class=\"arcade-lounge-key\">".concat(key.replace(/_/g, ' '), "</div></div>");
    }
  }
  return html;
};
var addTimeStamp = function addTimeStamp(label, datetime) {
  return detailRow(label, "".concat(datetime.hours, ":").concat(datetime.minutes, ", ").concat(datetime.day, " ").concat(datetime.month));
};